import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { FilterList, SettingsOutlined } from '@material-ui/icons';
import { SearchField } from '../../../../common/inputs/SearchField';
import { ToggleButton } from '../../../../common/buttons/ToggleButton';
import { RosterContext } from '../bulk-roster/RosterContext';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { ViewSelectorDropdown } from './ViewSelectorDropdown';

export enum RosterViewTypeEnum {
  SINGLE = 'singler',
  BULK = 'bulk',
}

interface RosterToolbarProps {
  title: string;
  onViewChange?: (view: 'single' | 'calendar' | 'bulk') => void;
  currentView?: 'single' | 'calendar' | 'bulk';
  isFiltering: boolean;
  setIsFiltering: (value: boolean) => void;
  onSetting: () => void;
  // Legacy prop for backward compatibility
  onView?: () => void;
}

export function RosterToolbar(props: RosterToolbarProps) {
  const { isFiltering, title, onViewChange, currentView = 'bulk', setIsFiltering, onSetting } = props;
  const { searchValue, setSearchValue } = React.useContext(RosterContext);
  const { theme } = useCampfireTheme();

  return (
    <Box display='flex' alignItems='center' justifyContent='space-between' paddingTop='10px' paddingBottom='18px'>
      <Box display='flex'>
        <Typography
          variant='h3'
          style={{ display: 'flex', fontWeight: 700, fontSize: 18, color: theme.color.grey.neutralBrand800 }}
        >
          {title}
        </Typography>
      </Box>
      <Box display={'flex'} alignItems='center'>
        <Box style={{ marginRight: '10px' }}>
          <SearchField
            data-track='rosterCnlFilter-SearchInput'
            placeholder='Search Rosters'
            growLeft
            value={searchValue}
            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              setSearchValue(event.target.value)
            }
          />
        </Box>
        <ToggleButton onClick={onSetting}>
          <SettingsOutlined />
          <Typography>Settings</Typography>
        </ToggleButton>
        <ToggleButton selected={isFiltering} onClick={() => setIsFiltering(!isFiltering)}>
          <FilterList />
          <Typography>Filters</Typography>
        </ToggleButton>
        {onViewChange ? <ViewSelectorDropdown currentView={currentView} onViewChange={onViewChange} /> : null}
      </Box>
    </Box>
  );
}
